import type { DateRangeConfig } from '@/types/api/modules/business-intelligence';
import { dayjs } from '@/utilities';

export type DateRangeBoundary = 'start' | 'end';

interface DatePickerValue {
    endOf(unit: 'day'): DatePickerValue;
    isValid(): boolean;
    startOf(unit: 'day'): DatePickerValue;
    toISOString(): string;
}

export const parseDateRangePickerValue = (value?: string) => {
    if (!value) {
        return null;
    }

    const parsed = dayjs(value);

    return parsed.isValid() ? parsed : null;
};

export const serializeDateRangePickerValue = (value: DatePickerValue | null, boundary: DateRangeBoundary) => {
    if (!value?.isValid()) {
        return undefined;
    }

    return (boundary === 'start' ? value.startOf('day') : value.endOf('day')).toISOString();
};

export const updateDateRangeBoundary = (
    dateRange: DateRangeConfig | undefined,
    boundary: DateRangeBoundary,
    value: DatePickerValue | null,
): DateRangeConfig | undefined => {
    const nextRange = {
        ...dateRange,
        [boundary]: serializeDateRangePickerValue(value, boundary),
        preset: 'custom' as const,
    };

    if (!nextRange.start && !nextRange.end) {
        return undefined;
    }

    return nextRange;
};
